import type { CurrencySummary } from '../../types/bankBalance';

interface BankBalanceSummaryProps {
    summary: CurrencySummary[];
}

function formatAmount(amount: number): string {
    if (Math.abs(amount) >= 1_000_000) {
        return (amount / 1_000_000).toFixed(1) + 'M';
    }
    if (Math.abs(amount) >= 1_000) {
        return (amount / 1_000).toFixed(0) + 'K';
    }
    return amount.toFixed(0);
}

export function BankBalanceSummary({ summary }: BankBalanceSummaryProps) {
    if (summary.length === 0) return null;

    return (
        <div className="flex flex-row flex-wrap sm:flex-col gap-1.5">
            {summary.map(s => (
                <div
                    key={s.CurrencyCode}
                    className="flex items-center justify-between gap-4 bg-white border border-gray-200 rounded-lg px-3 py-1.5 min-w-[140px]"
                >
                    <span className="text-xs font-medium text-gray-500">{s.CurrencyCode}</span>
                    <span className={`text-sm font-semibold tabular-nums ${s.TotalAmount >= 0 ? 'text-gray-900' : 'text-red-600'}`}>
                        {formatAmount(s.TotalAmount)}
                    </span>
                </div>
            ))}
        </div>
    );
}
